<template>
  <div class="l-row">
    <form-group label="Tipo de acréscimo" :columns="2">
      <select v-model="newItem.additionType" class="form-select">
        <option value="fixed">Fixo</option>
        <option value="percent">Percentual</option>
      </select>
    </form-group>

    <form-group label="Valor do acréscimo" :columns="2">
      <div class="form-flex">
        <money v-if="newItem.additionType === 'fixed'" class="form-input" v-bind="money" type="tel" v-model="newItem.additionValue"/>
        <input v-if="newItem.additionType === 'percent'" v-model="newItem.additionValue" type="number" class="form-input"/>
        <span v-if="newItem.additionType === 'percent'" class="form-addon">%</span>
      </div>
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <form-group label="De" :columns="2">
      <money class="form-input" type="tel" v-bind="money" v-model="newItem.from.minRange"/>
    </form-group>

    <form-group label="Até" :columns="2">
      <money class="form-input" type="tel"  v-bind="money" v-model="newItem.to.maxRange"/>
    </form-group>

    <slot/>
  </div>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import notifier from '@/notifier'
  import Multiselect from 'vue-multiselect'
  import { Money } from 'v-money'

  export default {
    data: () => ({
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      newItem: {
        from: {
          minRange: 0.0
        },
        to: {
          maxRange: 0.0
        },
        additionValue: 0.0,
        additionType: 'fixed'
      },
      items: [],
      alreadyExists: false
    }),
    props: {
      preset: {
        type: Object,
        required: true
      }
    },
    methods: {
      addPresetItem () {
        this.$emit('loading', true)

        this.alreadyExists = false

        const item = {
          from: {
            minRange: this.newItem.from.minRange
          },
          to: {
            maxRange: this.newItem.to.maxRange
          },
          additionValue: this.newItem.additionValue,
          additionType: this.newItem.additionType
        }
        if (this.preset.items.some(rangeItem => rangeItem.from.minRange <= item.from.minRange && rangeItem.to.maxRange >= item.from.minRange)) {
          notifier.warning('Você não pode cadastrar no intervalo entre faixas de valor.', 'Aviso')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        if (this.preset.items.some(rangeItem => rangeItem.from.minRange <= item.to.maxRange && rangeItem.to.maxRange >= item.to.maxRange)) {
          notifier.warning('Você não pode cadastrar no intervalo entre faixas de valor.', 'Aviso')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        if (this.preset.items.some(rangeItem => rangeItem.from.minRange >= item.from.minRange && rangeItem.to.maxRange <= item.to.maxRange)) {
          notifier.warning('Você não pode cadastrar no intervalo entre faixas de valor.', 'Aviso')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        if (this.newItem.additionValue === 0 || this.newItem.additionValue < 0) {
          notifier.warning('Valor do acréscimo não pode ser menor ou igual a zero.', 'Aviso')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        if (item.from.minRange === item.to.maxRange) {
          notifier.warning('Você não pode fazer a predefinição com a mesma faixa de valor.', 'Aviso')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        if (item.from.minRange >= item.to.maxRange) {
          notifier.warning('Você não pode fazer a predefinição com a faixa de valor DE sendo maior ou igual que a faixa de valor ATÉ.', 'Aviso')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        if (item.from.minRange < 0 || item.to.maxRange < 0) {
          notifier.warning('Você não pode fazer a predefinição com alguma das faixas de valor sendo menores que zero.', 'Aviso')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        const itemExist = this.preset.items.filter(
          itemPreset => (
            itemPreset.from.minRange === item.from.minRange &&
            itemPreset.to.maxRange === item.to.maxRange
          )
        )

        if (itemExist.length) {
          notifier.error('Esta predefinição já foi cadastrada.', 'Erro')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        this.preset.items.push(item)

        this.$emit('loading', false)
      },
      formatPreset () {
        return {
          'from': {
            'type': this.preset.from.type,
            'identifier': this.preset.from.identifier
          },
          'to': {
            'type': this.preset.to.type,
            'identifier': this.preset.to.identifier
          },
          'type': this.preset.type,
          'active': this.preset.active,
          'item': this.newItem
        }
      },
      emitEnabledAdd () {
        this.$emit('addItemEnable')
      }
    },
    watch: {
      'preset.items' (value) {
        this.items = value
      },
      'newItem.from.minRange' () {
        this.emitEnabledAdd()

        if (this.newItem.from.minRange === null) {
          this.newItem.from.minRange = 0
        }
      },
      'newItem.to.maxRange' () {
        this.emitEnabledAdd()

        if (this.newItem.to.maxRange === null) {
          this.newItem.to.maxRange = 0
        }
      },
      'newItem.additionType' (value) {
        if (value === null) {
          this.newItem.additionType = 'fixed'
        }
      },
      'newItem.additionValue' (value) {
        if (value === null) {
          this.newItem.additionValue = 0
        }
      }
    },
    components: {
      Panel,
      FormGroup,
      Multiselect,
      Money
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 81px
</style>



// WEBPACK FOOTER //
// AdditionAddItem.vue?7fa83daf